import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';
import {
  selectRating,
  selectReferralsCountStat
} from 'mt-react-common/modules/users/common/reducers/states/authAccount';

import { addClientNotice } from 'mt-react-common/modules/main/reducers/static/states/clientNotices/reducer';
import { HashLink } from 'react-router-hash-link';

// eslint-disable-next-line react/prefer-stateless-function
class ReferralTotalInfoBlock extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-xs-24 col-sm-8">
          <div className="panel panel-warning panel-footer_bg-sub text-center">
            <div className="panel-body">
              <div className="media media_inline-table media_widget">
                <div className="media-left avatar-md media-middle">
                  <div className="avatar avatar-icon avatar-icon-md avatar-icon-warning">
                    <i className="fa fa-percent fa-2x" />
                  </div>
                </div>
                <div className="media-body media-middle">
                  <span className="media_widget-val">
                    {this.props.rating.incomeRef1Lvl}
                  </span>{' '}
                  <span className="media_widget-title text-warning">
                    {t('Мой процент')}
                  </span>
                </div>
              </div>
            </div>
            <HashLink
              to={`/main/my-rating-and-stat/all-statuses/user-days-stat#complaints`}
              className="panel-footer text-muted"
              role="button"
              type="link"
            >
              {t('Расчет процента')}
            </HashLink>
          </div>
        </div>
        <div className="col-xs-24 col-sm-8">
          <div className="panel panel-primary panel-footer_bg-sub text-center">
            <div className="panel-body">
              <div className="media media_inline-table media_widget">
                <div className="media-left avatar-md">
                  <div className="avatar avatar-icon avatar-icon-md avatar-icon-primary">
                    <i className="fa fa-user fa-2x" />
                  </div>
                </div>
                <div className="media-body media-middle">
                  <span className="media_widget-val">
                    {this.props.referralsCountStat.count}
                  </span>
                  <span className="media_widget-title text-primary">
                    {t('Рефералов')}
                  </span>
                </div>
              </div>
            </div>
            <a
              className="panel-footer text-muted"
              data-toggle="scroll"
              href="#statMyAffiliates"
            >
              {t('Список пользователей')}
            </a>
          </div>
        </div>
        <div className="col-xs-24 col-sm-8">
          <div className="panel panel-success panel-footer_bg-sub text-center">
            <div className="panel-body">
              <div className="media media_inline-table media_widget">
                <div className="media-left avatar-md">
                  <div className="avatar avatar-icon avatar-icon-md avatar-icon-success">
                    <i className="fa fa-rub fa-2x" />
                  </div>
                </div>
                <div className="media-body media-middle">
                  <span className="media_widget-val">
                    {this.props.referralsCountStat.earned_amount}
                  </span>
                  <span
                    className="media_widget-title text-success"
                    data-container="body"
                    data-toggle="tooltip"
                    title=""
                    data-original-title={t(
                      'Заработано на партнерской программе'
                    )}
                  >
                    {t('Заработано')}
                  </span>
                </div>
              </div>
            </div>
            <a
              className="panel-footer text-muted"
              data-toggle="scroll"
              href="#statAffiliateMoney"
            >
              {t('Статистика')}
            </a>
          </div>
        </div>
      </div>
    );
  }
}

ReferralTotalInfoBlock.propTypes = {
  rating: PropTypes.shape({
    incomeRef1Lvl: PropTypes.number.isRequired
  }).isRequired,
  referralsCountStat: PropTypes.shape({
    count: PropTypes.number.isRequired,
    earned_amount: PropTypes.string.isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  rating: selectRating(state),
  referralsCountStat: selectReferralsCountStat(state)
});

const mapDispatchToProps = dispatch => ({
  addClientNotice: params => dispatch(addClientNotice(params))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReferralTotalInfoBlock);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/ReferralProgram/ReferralMyStat/ReferralTotalInfoBlock/ReferralTotalInfoBlock.js